




































































































import Vue from 'vue';
import { Component, Inject, Ref } from 'vue-property-decorator';
import BorderCard from '@/components/Helper/Card/BorderCard.vue';
import NoteIcon from '@/components/Helper/Icon/Svg/NoteIcon.vue';
import BulletinCommentList from '@/components/ViewComponent/Bulletin/BulletinComment/BulletinCommentList.vue';
import CommentBulletin from '@/components/ViewComponent/Bulletin/BulletinComment/CommentBulletin.vue';
import ReactionBulletin from '@/views/Bulletin/ReactionBulletin.vue';
import { UseService } from '@/services/service';
import BulletinService from '@/services/bulletin.service';
import { BulletinEntity } from '@/entities/bulletin.entity';
import { saveAs } from 'file-saver';
import { MimeTypes, getFileNameFromPath, MIME_TYPES } from '@/helper/file';
import UserAvatar from '@/components/Helper/UserAvatar.vue';
import { mapActions } from 'vuex';
import * as mime from 'mime-types';
import WatchingVideoBulletin from '@/views/Bulletin/WatchingVideoBulletin.vue';

@Component<BulletinDetail>({
  components: {
    WatchingVideoBulletin,
    UserAvatar,
    ReactionBulletin,
    CommentBulletin,
    BulletinCommentList,
    NoteIcon,
    BorderCard,
  },
  methods: {
    ...mapActions('staff', ['fetchCurrentStaff']),
  },
})
export default class BulletinDetail extends Vue {
  fetchCurrentStaff!: () => void;

  @Inject('toggleSideDrawer')
  toggleSideDrawer!: () => void;

  bulletin: BulletinEntity = null;

  loading = true;

  @Ref('comment-box')
  commentBox!: Vue;

  commentBoxHeight = 0;

  @UseService(BulletinService)
  service: BulletinService;

  get isVideo(): boolean {
    const mimeTypeOfFile: MimeTypes = mime.lookup(
      this.bulletin.file,
    ) as MimeTypes;
    return (
      MIME_TYPES.VIDEO.includes(mimeTypeOfFile) ||
      MIME_TYPES.AUDIO.includes(mimeTypeOfFile)
    );
  }

  get fileName() {
    return getFileNameFromPath(this.bulletin.file);
  }

  get id(): number {
    return this.$route.params.id as unknown as number;
  }
  async created(): Promise<void> {
    this.$cheeers.socket.on('bulletin@updated', async () => {
      this.bulletin = await this.service.getOne(this.id);
      this.loading = false;
    });
    this.loading = true;
    this.bulletin = await this.service.getOne(this.id);
    this.loading = false;
  }
  async mounted(): Promise<void> {
    const { id } = this.$route.params;
    if (id) {
      await this.$http.patch('/notify-bulletin/isread-notify-bulletin', {
        bulletinId: Number(id),
      });
    }
  }

  get contentHeight() {
    return `calc(100vh - ${65 + 130}px)`;
  }

  download = saveAs;
}
